import React from "react";
import ProfileBox from "./Module/ProfileBox";
import { Card, CardHeader } from "reactstrap";
import Favorite from "../../Favorite";
import { useQuery } from "@apollo/client";
import {
  useLoginStatus,
  useUserEmail,
} from "../../../Layout/AppMain/LoginStatusContext";
import { GET_USER_PROF } from "../../../queries";
import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";

const SettingProfilePersonDashboard = () => {
  const loginStatus = useLoginStatus();

  const userEmail = useUserEmail();

  // クエリ
  const { loading, error, data, refetch } = useQuery(GET_USER_PROF, {
    variables: { email: userEmail },
  });

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    alert("ログイン制限時間が切れました、再リロードしてください。");
    window.location.href = "/#/dashboards/journy";
    window.location.reload();
  }
  if (!data) return "...Not Found";

  const userData = data.allUsers.edges.map((array) => array.node);
  const { allSdgs, allNpoQuetionnaireItems } = data;

  return (
    <>
      <div>
        <ProfileBox
          userData={userData}
          allSdgs={allSdgs}
          allNpoQuetionnaireItems={allNpoQuetionnaireItems}
          refetch={refetch}
        />
      </div>
      <Favorite userId={loginStatus} refetch={refetch} />
    </>
  );
};

export default SettingProfilePersonDashboard;
